import { css } from 'emotion';

import { fonts } from '@cobliteam/base-components';

export const badge = (color: string) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  max-width: 41px;
  height: 25px;
  font-size: 9px;
  font-weight: ${fonts.weight.bold};
  color: ${color};
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  border: solid 1px ${color};
  box-sizing: border-box;
`;
